import React from 'react';
import * as styles from './SearchLinkSelectOption.module.scss';

interface SearchLinkSelectOptionProps {
  label: React.ReactNode;
}

const SearchLinkSelectOption = (props: SearchLinkSelectOptionProps) => {
  return <div className={styles.searchLink}>{props.label}</div>;
};

export default SearchLinkSelectOption;
